<div class="message-line">
    <div class="chat-info">
        <div class="info">
            <div class="title">{{ chat?.name }} #{{ chat?.id }}</div>
            <div class="users overflow-ellipsis">
                {{ chat?.created_at | date: 'EEEE d MMM yyyy H:mm' }} -
                @for (user of chat.chat_users; track user.id; let last = $last) {
                    {{ user?.user?.name }}{{ last ? '' : ', ' }}
                }
            </div>
        </div>
        <div class="actions">
            @if (selectedItems.size > 0) {
                @if (enableCopy) {
                    <button (click)="copyMessage($event)" mat-icon-button matTooltip="Kopieër berichten">
                        <mat-icon class="fas fa-copy"></mat-icon>
                    </button>
                }
                @if (enableDelete) {
                    <button (click)="deleteMessages($event)" mat-icon-button matTooltip="Verwijder berichten">
                        <mat-icon class="fas fa-trash"></mat-icon>
                    </button>
                }
            }
            @if ((Functionalities.ChatsManagement | hasFunctionality) && chat?.lat > 0) {
                <button (click)="openNavi()" mat-icon-button matTooltip="GPS-locatie tijdens aanmaken melding">
                    <mat-icon class="fas fa-map"></mat-icon>
                </button>
            }
            @if (Functionalities.ChatsManagement | hasFunctionality) {
                <button (click)="editChat()" mat-icon-button matTooltip="Melding aanpassen">
                    <mat-icon class="fas fa-edit"></mat-icon>
                </button>
            }
            <button routerLink="/{{ Routenames.chat }}" class="close" mat-icon-button>
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
    @if (datasource) {
        <div class="messages">
            <ng-container *uiScroll="let message of datasource; let i = index">
                <div
                    (mousedown)="select($event, message)"
                    (press)="selectStart(message)"
                    (touchstart)="select($event, message)"
                    [class.deleted]="message.deleted_at"
                    [class.own]="LocalStorage.getUser().id === message.user_id"
                    [class.selected]="selectedItems && selectedItems.has(message.id)"
                    [class.last]="
                        i + 2 === chatMessageService.totalCount && (Functionalities.ChatsManagement | hasFunctionality)
                    "
                    [class.unread]="lastRead < message.id"
                    class="message">
                    <div>
                        <div class="info">
                            @if (message.user_id === LocalStorage.getUser().id) {
                                <div class="name">
                                    {{
                                        (Functionalities.ChatsManagement | hasFunctionality)
                                            ? 'D. van der Steen'
                                            : 'Jij'
                                    }}
                                </div>
                            } @else {
                                <div class="name">
                                    {{
                                        (chat.chat_users | byId: message.user_id : 'user_id')?.user?.name ||
                                            'D. van der Steen'
                                    }}
                                </div>
                            }
                            <div></div>
                            <div class="date">
                                @if (Utils.isToday(message.updated_at)) {
                                    {{ message.updated_at | date: 'H:mm' }}
                                } @else {
                                    <span class="d-none d-sm-block">
                                        {{ message.updated_at | date: 'd MMM yyyy H:mm' }}
                                    </span>
                                    <span class="d-block d-sm-none">
                                        {{ message.updated_at | date: 'd MMM H:mm' }}
                                    </span>
                                }
                            </div>
                        </div>
                        @if (message.message | isBase64) {
                            <div
                                (click)="openImage(message.message)"
                                [style.background-image]="message.message | safeBgUrl"
                                class="image"></div>
                        } @else {
                            <div [innerHTML]="message.message" class="text"></div>
                        }
                    </div>
                </div>
            </ng-container>
            @if (Functionalities.ChatsManagement | hasFunctionality) {
                <div class="status-buttons">
                    <p>Wijzig de status van deze melding naar:</p>
                    <div>
                        @for (status of statuses | filter: chat.status_id : 'id' : true; track status) {
                            <button
                                (click)="statusChange(status)"
                                [style.background-color]="'#' + status.colorcode"
                                class="me-2 ms-2"
                                color="primary"
                                mat-raised-button>
                                {{ status.name }}
                            </button>
                        }
                    </div>
                </div>
            }
        </div>
    }
    <div class="d-flex composer">
        @if (chat.status.releasenumber && !(Functionalities.ChatsManagement | hasFunctionality)) {
            <div class="flex-fill d-flex flex-column align-items-center">
                <i>
                    Deze melding is afgehandeld door DvdSteen. Bent u nog niet tevreden? Dan kunt u deze melding
                    heropenen.
                </i>
                <button (click)="reopen()" color="primary" mat-button>Melding heropenen</button>
            </div>
        } @else if (!chat.status.releasenumber) {
            <form [formGroup]="form" class="flex-fill me-2">
                <mat-form-field appearance="fill" class="w-100 mt-3">
                    <textarea
                        #autosize="cdkTextareaAutosize"
                        (keyup)="sendMessage($event)"
                        cdkAutosizeMaxRows="5"
                        cdkAutosizeMinRows="1"
                        cdkTextareaAutosize
                        formControlName="message"
                        matInput
                        placeholder="Typ een bericht"></textarea>
                    <mat-error [control]="form.get('message')"></mat-error>
                    @if (isNativePlatform) {
                        <button (click)="camera($event)" color="primary" mat-icon-button matSuffix>
                            <mat-icon class="fas fa-image" color="primary"></mat-icon>
                        </button>
                    } @else {
                        <button class="curpoint" mat-icon-button matSuffix>
                            <div (click)="uploadInput.click()">
                                <mat-icon class="fas fa-image" color="primary"></mat-icon>
                                <input
                                    #uploadInput
                                    (change)="uploadFile($event)"
                                    [multiple]="true"
                                    hidden
                                    type="file" />
                            </div>
                        </button>
                    }
                </mat-form-field>
            </form>
            <div class="d-flex align-items-center justify-content-center">
                <button (click)="sendMessage()" [disabled]="sending || form.invalid" color="primary" mat-mini-fab>
                    <svg-icon src="assets/images/icons/send.svg"></svg-icon>
                    @if (sending) {
                        <mat-icon class="fas fa-circle-notch fa-spin"></mat-icon>
                    }
                </button>
            </div>
        }
    </div>
</div>
